import uploadsaboutUssidebysideimagelCole20238916CopyJpg from "$lib/data/generated/uploads/about us/SideBySide/image/L-Cole-2023-8916-copy.jpg";

export const uploads = {
  "uploads/about us/SideBySide/image/L-Cole-2023-8916-copy.jpg": uploadsaboutUssidebysideimagelCole20238916CopyJpg
};